// src/widgets/Empty.jsx

export default function Empty({ message = 'Tidak ada data' }) {
  return (
    <div style={{
      height: '100%',
      minHeight: 60,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: 'var(--text-muted)',
      fontSize: 12,
    }}>
      {message}
    </div>
  );
}